<template>
  <NSelect :bordered="false" :class="{ 'n-select--no-arrow': !props.showArrow }" :showArrow="props.showArrow">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>

    <template #arrow>
      <CIcon icon="chevron-down" />
    </template>
  </NSelect>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { NSelect } from 'naive-ui'

interface Props {
  showArrow?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showArrow: true,
})
defineSlots()
</script>

<style lang="scss" scoped>
.n-select {
  &--no-arrow {
    :deep(.n-base-selection .n-base-selection-label .n-base-selection-input) {
      padding-right: 16px;
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
.n-base-select-menu-option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.n-base-selection-input__content,
.n-base-select-option__content {
  letter-spacing: 1.25px;
}

.n-base-select-option--pending,
.n-base-select-option--selected {
  &:before {
    left: 8px;
    right: 8px;
  }
}

.n-base-select-option--selected:before {
  border: 1px solid var(--n-option-text-color-active);
}

.n-base-select-option__content .n-base-select-option--hide-option-icon .n-icon {
  display: none;
}
</style>
